"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.FA_SLC_CONGRATS_CONTENT = exports.SLC_CLASSIC_CONGRATS_CONTENT = exports.SLC_CONGRATS_CONTENT = void 0;
var AUTOPAY = {
    BODY: 'You’re ready to Flex your rent! Each month, Flex will automatically pay your rent and process your payments, starting with your',
    BODY_TWO: ' bill. Check your email for more info!',
    DOWNLOAD: 'Download the app to keep up-to-date with your Flex status.'
};
var AUTOPAY_OFF = {
    BODY: 'Split your rent whenever you want, starting in',
    BODY_TWO: '. Just use the app to kick off your rent payment process. Check your email for more info!',
    DOWNLOAD: 'Download the Flex app to get started.'
};
exports.SLC_CONGRATS_CONTENT = {
    HEADER: 'Congrats!',
    CTA: 'Finish',
    AUTOPAY: AUTOPAY,
    AUTOPAY_OFF: AUTOPAY_OFF,
    BODY: ''
};
exports.SLC_CLASSIC_CONGRATS_CONTENT = __assign(__assign({}, exports.SLC_CONGRATS_CONTENT), { CTA: 'Done', BODY: 'You’re ready to Flex your rent. Flex will automatically pay your rent bill and process your payments each month, starting with {{month}} {{year}}.' });
exports.FA_SLC_CONGRATS_CONTENT = __assign(__assign({}, exports.SLC_CLASSIC_CONGRATS_CONTENT), { CTA: 'Done', BODY: 'You’re ready to Flex your rent. Check your email for more info!' });
